import axios from 'axios';
import React, { useState } from 'react'
import { baseUrl } from '../urlApi';

export const ModalMailConfirm = ({setEnrolado,enrolamiento,closeModalMail,email}) => {

    // console.log(email,'email')

    

    const conid = localStorage.getItem('conid')

    const [codeInput, setCodeInput] = useState('')

    const [invalidCode, setinvalidCode] = useState(false)
    const [validCode, setValidCode] = useState(false)

    const validarEmail = async () => {



        // console.log('dataEnviada', codeInput,conid)

        try {

            const response = await axios.post(`${baseUrl}emailok.asp`,{
             pe:conid,codigo:codeInput
            });

            // console.log(response.data)

            if(response.data.validacion === '1' && setEnrolado ){
                localStorage.removeItem('emailok')
                localStorage.setItem('emailok','S')
                setValidCode(true)

                setTimeout(() => {

                    setEnrolado(true)

                        
                }, 4000);
            }

            if(response.data.validacion === '1' && !setEnrolado ){
               
                localStorage.removeItem('emailok')
                localStorage.setItem('emailok','S')
                setValidCode(true)

                setTimeout(() => {

                closeModalMail()
                    
                }, 4000);
            }

            if(response.data.validacion !=='1'){
                setinvalidCode(true)
            }
            
        } catch (error) {

            console.log(error)

        }

     
    }







  return (
    <div className='modalMail' >


        {
            enrolamiento !== 'si' ? <p className='bienvenidoMail' >Bienvenido al portal de AutoConsulta de Websal</p> : <p className='bienvenidoMail' >Bienvenido al modulo de firma digital</p>
        }
        {
            enrolamiento !== 'si' && <button onClick={closeModalMail} className='cerrarModal' > x </button>
        }

        {/* <p className='bienvenidoMail' >Bienvenido al portal de AutoConsulta de Websal</p> */}


        {
            email || localStorage.getItem("email") ? 

            <>

                <p className='textoMail' >Te enviamos un código a tu email <span>{email || localStorage.getItem("email")}</span></p>
                <p className='textoMail '>Ingrésalo para confirmar tu correo.</p>

                <div className='inputContainer'>
                    <input  value={codeInput.toUpperCase()} onChange={ (e) => setCodeInput(e.target.value) } placeholder='Código recibido' />

                </div>

                <div className='contenedorButton'>
                <button className='baseButton' disabled={validCode}  onClick={validarEmail} > Validar </button>

                </div>


                {
                    invalidCode && !validCode && <p className='codigoIncorrecto'>Código incorrecto o vencido. Si el código venció vuelve a iniciar sesión para recibir otro. </p>
                }

                {
                    validCode && <p className='codigoCorrecto'>Has validado tu correo correctamente</p>
                }


                <p className='advertencia' >Es importante que valides tu correo para utilizar las funciones de la firma digital y recuperar tu contraseña.</p>

        
        
        </> :

          <>
            <p className='textoMail' >No tienes un correo ingresado, solicita al encargado de recursos humanos de tu empresa que proporcione esta información.</p>
            <p className='textoMail' >Es importante que valides tu correo para utilizar las funciones de la firma digital y recuperar tu contraseña.</p>
          
          </>
        }


        
    

      


    </div>
  )
}
